import * as React from "react";
import { Appointment } from "@teamprevent/common/calendar";
import { Header, Icon } from "semantic-ui-react";

interface Props {
    appointment: Appointment;
}

export const AppointmentModalHeader: React.FC<Props> = (props: Props) => (
    <Header>
        <Icon name="calendar alternate" />
        <Header.Content>
            {props.appointment && props.appointment.description}
            <Header.Subheader>{props.appointment &&
                props.appointment.start.format("LL")}</Header.Subheader>
            <Header.Subheader>
                {props.appointment && props.appointment.start.format("LT")} -
                {props.appointment && props.appointment.end.format("LT")}
            </Header.Subheader>
        </Header.Content>
    </Header>
);
